module.exports = __webpack_public_path__ + "img/clock.2bb77f78.svg";